import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from 'store/configureStore';
import { reportingOp } from 'store/ducks/Reportings';
import { set_selectedDate } from 'store/ducks/Reportings/reportingSlice';
import { useHierarchicalTreePage } from 'utils/hooks/useHierarchicalTreePage';
import { buildEntityToTPPTree } from './EntityToTPPTreeBuilder';
import HierarchicalTreePage from '../HierarchicalTreePage';
import { TitleList } from 'store/ducks/globalTypes';
import { useTranslation } from 'react-i18next';

const EntityToTPPTree: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const { date } = useSelector((state: RootState) => state.reportings);
  const { t } = useTranslation();
  const [selectedEntityId, setSelectedEntityId] = useState<number | null>(null);

  const { data, entityOptions } = useHierarchicalTreePage(
    reportingOp.filterEnityToTPPChain,
    (res) => res?.data || [],
    selectedEntityId,
    date,
  );

  return (
    <HierarchicalTreePage
      title={t(TitleList.ENTITYTOTPP)}
      data={data}
      entityOptions={entityOptions}
      selectedEntityId={selectedEntityId}
      setSelectedEntityId={setSelectedEntityId}
      onDateChange={(dateString) => {
        dispatch(set_selectedDate(dateString));
      }}
      buildTree={buildEntityToTPPTree}
    />
  );
};

export default EntityToTPPTree;
